/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React, { FC } from "react";
import IconNotFound from "../assets/icons/link-not-found.svg";
import { AppLogo } from "@advapacs/common";

interface ILinkNotFound {
  showFooter?: boolean;
  message?: string;
  showHomeButton?: boolean;
}

export const LinkNotFound: FC<ILinkNotFound> = ({
  showFooter = true,
  message = "The link may be invalid. Please check if the link is correct. You can contact your provider for further assistance.",
  showHomeButton = false,
}) => {
  return (
    <>
      <div
        className={`d-flex align-items-center w-100 p-t-2xl link-not-found ${
          !showFooter ? "no-footer" : ""
        } p-b-xls`}
      >
        <img src={IconNotFound} alt="Icon Not Found" className="m-b-lg icon" />
        <h3 className="font-weight m-b-xs text-link-not-found">
          This Page Isn’t Available
        </h3>
        <p className="text-center text-link-not-found">{message}</p>
        {showHomeButton && (
          <button
            type="button"
            className="btn btn-primary m-t-sm"
            onClick={() => window.location.assign(window.location.origin)}
          >
            Go to Home Page
          </button>
        )}
      </div>
      {showFooter && (
        <div className="w-100 bg-white landing-footer notfound-footer navbar-text">
          <div className="w-100 text-center p-t-xs m-b-xxs">
            <AppLogo.LogoLong />
          </div>
          <p className=" w-100 text-center m-t-none text-label m-b-none">
            © {new Date().getFullYear()} AdvaPACS by{" "}
            <a href="https://adva.health" target="_blank">
              AdvaHealth Solutions
            </a>
          </p>
        </div>
      )}
    </>
  );
};
